/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { CategoryMapping } from "./CategoryMapping";
import { EnumValue } from "./EnumValue";
export const EnumDetails = core.serialization.object({
    mapping: core.serialization.list(CategoryMapping),
    unusedSourceValues: core.serialization.list(EnumValue).optional(),
    unusedDestinationValues: core.serialization.list(EnumValue).optional(),
});
